import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useState } from "react";

export default function BirthDatePicker({ inputClass, inputValue, setInputValue }) {
  const [textValue, setTextValue] = useState(
    inputValue instanceof Date ? formatDate(inputValue) : ""
  );

  // Функция форматирования "дд.мм.гггг"
  function formatDate(date) {
    if (!date) return "";
    const d = String(date.getDate()).padStart(2, "0");
    const m = String(date.getMonth() + 1).padStart(2, "0");
    const y = date.getFullYear();
    return `${d}.${m}.${y}`;
  }

  // Парсер строки в объект Date
  function parseDate(value) {
    const parts = value.split(".");
    if (parts.length === 3) {
      const [day, month, year] = parts.map(Number);
      const parsed = new Date(year, month - 1, day);
      if (!isNaN(parsed.getTime())) return parsed;
    }
    return null;
  }

  // Функция автоформатирования ввода
  function autoFormat(value) {
    const digits = value.replace(/\D/g, "");
    let result = "";
    if (digits.length <= 2) result = digits;
    else if (digits.length <= 4) result = `${digits.slice(0, 2)}.${digits.slice(2)}`;
    else if (digits.length <= 8)
      result = `${digits.slice(0, 2)}.${digits.slice(2, 4)}.${digits.slice(4)}`;
    else result = `${digits.slice(0, 2)}.${digits.slice(2, 4)}.${digits.slice(4, 8)}`;
    return result;
  }

  // При выборе из календаря
  const handleChange = (date) => {
    setInputValue(date);
    setTextValue(formatDate(date));
  };

  // При ручном вводе
  const handleInputChange = (e) => {
    const formatted = autoFormat(e.target.value);
    setTextValue(formatted);

    if (formatted.length === 10) {
      const parsed = parseDate(formatted);
      if (parsed) {
        setInputValue(parsed);
      }
    }
  };

  return (
    <DatePicker
      selected={inputValue instanceof Date ? inputValue : null}
      onChange={handleChange}
      placeholderText="Дата рождения (дд.мм.гггг)"
      dateFormat="dd.MM.yyyy"
      dropdownMode="select"
      customInput={
        <input
          type="text"
          value={textValue}
          onChange={handleInputChange}
          className={inputClass}
        />
      }
    />
  );
}
